import {setBattleValue} from '../../redux-actions/battle-actions.js'
import {getNewTurnSeries} from '../lifecycle/start-turn-series.js'
import {offlineCheckForAutoSubmission} from '../offline/offline-check-for-auto-submissions.js'
import {buildTeamsFromCombatantData} from '../lifecycle/build-teams-from-combatant-data.js'
import {getInitialBattleState} from '../lifecycle/init-battle.js'
import {getBattleEndReport} from '../analysis/get-battle-end-report.js'
import store from '../../init/store.js'

export function runFullBattle(battleCombatants, finalCallback) {

  // FIRST, Reset the state so that we're clear for a fresh battle! ------------------------------------------

  //Make sure all combatants are bots
  Object.keys(battleCombatants).forEach(combId => {
    battleCombatants[combId] = {
      ...battleCombatants[combId],
      isBot: true
    }
  });

  //Build teams and set initial state for offline battle
  const teams = buildTeamsFromCombatantData(battleCombatants);
  setBattleValue({
    ...getInitialBattleState(battleCombatants, teams)
  });

  //Set up the first turn
  const initialSeries = getNewTurnSeries();
  setBattleValue({
    ...initialSeries
  });

  // NEXT, Run the battle! We call `finalCallback` with the result when we're finished! ---------------------

    //Kicks off the first action. The rest will automatically trigger
    offlineCheckForAutoSubmission();

    //We don't know when it will end though, (because we don't have clear callbacks on individual turns..
    // it just doesn't make as much sense outside of Reporting mode)

    //So start a poll sequence to check when this battle is done.
    function checkIfBattleIsOver() {
      //Check for rolloutId: "rollout_battle-over"
      const rolloutId = store.getState().battle.rolloutId;
      if (rolloutId === "rollout_battle-over") {

        //Get the battle report and pass into final callback!
        finalCallback( getBattleEndReport() );

      } else {
        //This battle is still running Try again in a few ms.
        // console.log('will retry')
        setTimeout(checkIfBattleIsOver, 100);
      }
    }
    setTimeout(checkIfBattleIsOver, 100);

}


// WEBPACK FOOTER //
// ./src/battle/reporting-mode/run-full-battle.js